import { ChangeEvent, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../TextField/TextField';
import { ReactComponent as VisibleEyeIcon } from './visibleEyeIcon.svg';
import { ReactComponent as HiddenEyeIcon } from './hiddenEyeIcon.svg';
import './PasswordField.css';

type Props = {
  value: string;
  label: string;
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  actionComponent?: ReactElement;
  autoFocus?: boolean;
  'aria-describedby'?: string;
  autoComplete?: string;
  errorMessage?: string | null;
};

export function PasswordField(props: Props) {
  const { t } = useTranslation();
  const [isRevealed, setIsRevealed] = useState(false);
  return (
    <TextField {...props} className="password-input" type={isRevealed ? 'text' : 'password'}>
      <button
        type="button"
        className="show-hide-password-button"
        onClick={() => setIsRevealed(!isRevealed)}
        title={isRevealed ? t('hidePassword') : t('revealPassword')}
      >
        {isRevealed ? <HiddenEyeIcon /> : <VisibleEyeIcon />}
      </button>
    </TextField>
  );
}
